import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdCanvasWorkflowIdContentOptimizationStepIdPerformanceContext } from "./constants";
import type {
  GetContentOptimizationPerformanceContextProps,
  GetContentOptimizationPerformanceContextResult,
} from "./types";
import { isGetContentOptimizationPerformanceContextResult } from "./validators";

export const getContentOptimizationPerformanceContext = reactQueryFetcherAdapter(
  engagementAppGroupIdCanvasWorkflowIdContentOptimizationStepIdPerformanceContext,
  (
    signal: AbortSignal,
    { appGroupId, workflowId, stepId, componentName }: GetContentOptimizationPerformanceContextProps
  ): Promise<GetContentOptimizationPerformanceContextResult> => {
    return fetch(
      `/engagement/${appGroupId}/canvas/${workflowId}/content_optimization/${stepId}/performance_context`,
      "GET",
      { component_name: componentName },
      { signal }
    );
  },
  isGetContentOptimizationPerformanceContextResult
);
